import { injectJS } from './utils';
import { Capacitor } from '@capacitor/core';

export async function initWootric(
  email: string,
  external_id: string,
  created_at: number
) {
  // window['wootric_survey_immediately'] = true; // only for testing;
  window['wootricSettings'] = {
    email,
    external_id,
    created_at,
    account_token: 'NPS-1014f630',
    channel: Capacitor.isNativePlatform() ? 'mobile' : 'web',
    // callbacks: {
    //   after_eligible: eligible => {
    //     console.debug('Eligibility returned:', eligible);
    //   },
    //   after_show: () => {
    //     console.debug('The Wootric modal is visible');
    //   },
    //   after_response: (score, text) => {
    //     console.debug(
    //       'A response has been submitted with score:',
    //       score,
    //       'and text',
    //       text
    //     );
    //   },
    //   after_decline: () => {
    //     console.debug('A decline has been submitted');
    //   }
    // }
  };
  console.debug('init wootric', window['wootricSettings']);
  await injectJS('wootric', 'https://cdn.wootric.com/wootric-sdk.js');
  if (window['wootric']) {
    window['wootric']('run');
  }
}
